//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Avatar from "./avatar.vue";
import Award from "@/components/stockAward";
import { conversion, GetItemDuration } from "@/tool";
export default {
  name: "RoomItem",
  components: { "c-avatar": Avatar, "c-award": Award },
  props: {
    room: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  filters: {
    conversion,
  },
  computed: {
    GetItemDuration,
  },
  created() {},
  beforeDestory() {},
  methods: {},
};
